'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.couponsSearch = couponsSearch;

var _constants = require('redux/constants');

function couponsSearch(token) {
    var user_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return {
        types: [_constants.CouponsConstants.LOAD_COUPONS, _constants.CouponsConstants.LOAD_COUPONS_SUCCESS, _constants.CouponsConstants.LOAD_COUPONS_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getCouponsByToken(token, user_id);
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/coupons.js
// module id = 1861
// module chunks = 0